<template>
 <div>
    <PageTagline :elements="tagline_elem" />

    <!-- Overlay di caricamento -->
    <CustomOverlay :show="overlay_show" :text="overlay_text">

      <!--CARD PRINCIPALE DI CONTENIMENTO DEL TEMPLATE -->
      <!-- Deve renderizzarsi solo quando i dati sono stati caricati non prima -->
      <!-- altrimenti abbiamo un errore -->
      <b-card v-if="dati_articolo != null && dati_fornitore != null">
        <!-- Un pulsante per tornare alla vetrina del fornitore -->
        <b-row class="mb-3">
          <b-col>
            <b-button pill size="sm" @click="torna_alla_vetrina">
              <b-icon icon="caret-left-fill"></b-icon>Torna alla vetrina
            </b-button>
          </b-col>
        </b-row>
        <!-- Template: tmpl_default -- "Articolo senza immagini" -->
        <div v-if="dati_articolo.id_template.nome === 'tmpl_default'">
          <DefaultTmpl :dati_articolo="dati_articolo" :dati_fornitore="dati_fornitore"
                   @onAcqSubmit="show_overlay_on_acq" @onAcqComplete="hide_overlay" @onAcqError="hide_overlay"/>
        </div>
        <!-- Template: tmpl_default -- "Articolo senza immagini - senza email fornitore" -->
        <div v-else-if="dati_articolo.id_template.nome === 'tmpl_default_no_mail'">
          <DefaultTmpl :dati_articolo="dati_articolo" :dati_fornitore="dati_fornitore" :hide_email="true"
                   @onAcqSubmit="show_overlay_on_acq" @onAcqComplete="hide_overlay" @onAcqError="hide_overlay"/>
        </div>
        <!-- Template: tmpl_with_images -- "Articolo con immagini" -->
        <div v-else-if="dati_articolo.id_template.nome === 'tmpl_with_images'">
          <ImagesTmpl :dati_articolo="dati_articolo" :dati_fornitore="dati_fornitore"
                  @onAcqSubmit="show_overlay_on_acq" @onAcqComplete="hide_overlay" @onAcqError="hide_overlay"/>
        </div>
        <!-- Template: tmpl_with_images -- "Articolo con immagini - senza email fornitore" -->
        <div v-else-if="dati_articolo.id_template.nome === 'tmpl_with_images_no_mail'">
          <ImagesTmpl :dati_articolo="dati_articolo" :dati_fornitore="dati_fornitore" :hide_email="true"
                  @onAcqSubmit="show_overlay_on_acq" @onAcqComplete="hide_overlay" @onAcqError="hide_overlay"/>
        </div>
        <div v-else>
          <h5>Template non trovato</h5>
        </div>
      </b-card>

    </CustomOverlay>
  </div>

</template>

<script>
import PageTagline from '@/components/PageTagline'
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

// I templates a disposizione ( caricati anche nella sezione components )
import DefaultTmpl from '@/components/fornitori/template_articoli/DefaultTmpl'
import ImagesTmpl from '@/components/fornitori/template_articoli/ImagesTmpl'

export default {
  name: 'VetrinaArticolo',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "Convenzioni special", link : 'home-fornitori' },
                       { text : "Visualizza Articolo", link : '' }  ],

      overlay_show: false,

      // Mettiamo una variabile per il testo dell'overlay, esso sarà
      // diverso durante il caricamento della vetrina o l'esecuzione dell'acquisto.
      overlay_text: null,

      // Dati sull'articolo da visualizzare
      dati_articolo: null,

      // Dati sul fornitore
      dati_fornitore: null
    }
  },
  methods: {
    /**
     * Torna alla vetrina del fornitore di questo articolo.
     */
    torna_alla_vetrina : function () {
      this.$router.push( { name : 'vetrina-fornitore', params : { id_fornitore : this.dati_fornitore.id } } )
    },
    /**
     * Mostra l'overlay durante la procedura di acquisto, settando la corretta
     * stringa informativa
     */
    show_overlay_on_acq : function () {
      this.overlay_text = "Richiesta in corso, attendere...";
      this.overlay_show = true;
    },
    /**
     * Nasconde l'overlay
     */
    hide_overlay : function () {
      this.overlay_show = false;
    }
  },
  /**
   * Al created carichiamo le informazioni sull'articolo, grazie ad esse
   * andiamo anche a caricare le informazioni sul fornitore, infatti nell'articolo
   * è contenuto l'id del fornitore che lo ha pubblicato.
   */
  created : function () {
    this.overlay_text = "Caricamento in corso, attendere...";
    this.overlay_show = true;
    let info_art_call_url = apiUrl.fornitoriapi.get_info_articolo.replace( '@id_articolo', this.id_articolo );

    axios.get ( info_art_call_url )
    .then( ( response ) => {

      // Memorizziamo le info dell'articolo, poi da esse prendiamo
      // l'id del fornitore e quindi carichiamo anche le info del fornitore
      this.dati_articolo = response.data;
      let info_forn_call_url = apiUrl.fornitoriapi.get_info_fornitore.replace( '@id_fornitore', this.dati_articolo.id_fornitore );

      axios.get ( info_forn_call_url )
      .then( ( response ) => {
        this.dati_fornitore = response.data;
        this.overlay_show = false;
      })
      .catch( (error) => {
        this.overlay_show = false;
        generalLib.backend_error_message_box( this, error.response.data );
      });

    })
    .catch( ( error ) => {
      this.overlay_show = false;
      generalLib.backend_error_message_box( this, error.response.data );
      console.error( error.response.data );
    });
  },
  components: {
    PageTagline,
    CustomOverlay,
    DefaultTmpl,
    ImagesTmpl
  },
  props : {
    /**
     * Id dell'articolo da visualizzare
     */
    id_articolo: {
      type: [ String, Number ],
      required: true
    }
  }
}
</script>

<style scoped></style>